import { Injectable } from "@angular/core";
import { ITabTemplate } from "./i-tab-template";
import { CloudIdStorageService } from "../cloud/cloud-id-storage.service";
import { RegionStorageService } from "../region/region-storage.service";
import { ConfigurationService } from '../configuration/configuration.service';

@Injectable({
  providedIn: "root",
})
export class TabTemplateFactoryService {

  get configuration() {
    return this.configurationService.configuration;
  }

  get disabledTabTemplates() {
    if (this.configuration) {
      return this.configuration.disabledTabTemplates;
    } else {
      return [];
    }
  }


  constructor(
    private cloudIdStorageService: CloudIdStorageService,
    private regionStorageService: RegionStorageService,
    private configurationService: ConfigurationService
  ) {}

  createTemplate(baseTemplate: ITabTemplate, name: string): ITabTemplate {
    return {
      ...baseTemplate,
      baseTemplateName: baseTemplate.name,
      name: name,
      cloudId: this.loadCloudId(),
      region: this.loadRegion(),
      enabled: !this.tabTemplateDisabled(baseTemplate.name)
    };
  }

  loadCloudId() {
    return this.cloudIdStorageService.loadCloudId();
  }

  loadRegion() {
    return this.regionStorageService.loadRegion();
  }

  tabTemplateDisabled(templateName) {
    return !!this.disabledTabTemplates.find((t) => t === templateName);
  }
}
